/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_UpdatedInputs */

const en_gc_guides_updated = /** @type {(inputs: Gc_Guides_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated November 5, 2026 · Covers v0.7.0`)
};

const zh_gc_guides_updated = /** @type {(inputs: Gc_Guides_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新于 2026 年 11 月 5 日 · 适用于 v0.7.0`)
};

/**
* | output |
* | --- |
* | "Updated November 5, 2026 · Covers v0.7.0" |
*
* @param {Gc_Guides_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_updated = /** @type {((inputs?: Gc_Guides_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_updated(inputs)
	return zh_gc_guides_updated(inputs)
});
export { gc_guides_updated as "gc.guides.updated" }